import LogoTabletImage from '@/assets/logo-small.png';
import LogoPcImage from '@/assets/logo-white.png';
import { UserIconMenu } from '@/components/UserIconMenu/UserIconMenu';
import { TrackingFeatureGate } from '@/features/tracking/components/TrackingFeatureGate';
import { useUser } from '@/lib/auth';
import { PRIVATE_TOP_PATH } from '@/constants/routes';
import clsx from 'clsx';
import React from 'react';
import { AppToggle } from '../Elements/AppToggle';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

type LayoutProps = {
  backgroundClassName?: string;
  children: React.ReactNode;
};

export const Layout = ({
  backgroundClassName = 'bg-white',
  children,
}: LayoutProps) => {
  const { data: user } = useUser();
  const isAuthenticated = Boolean(user);

  return (
    <div className={clsx('flex h-screen', backgroundClassName)}>
      <div className="flex w-0 flex-1 flex-col overflow-hidden">
        {/* Header */}
        <div className="relative z-10 flex h-[60px] shrink-0 bg-rw-sub">
          <div className="flex flex-1 items-center justify-center px-4">
            {/* Left section */}
            <div className="flex items-center gap-2">
              <a href={PRIVATE_TOP_PATH}>
                <img
                  src={LogoPcImage}
                  alt="logo image"
                  className="hidden h-8 md:block"
                />
                <img
                  src={LogoTabletImage}
                  alt="logo image"
                  className="h-10 md:hidden"
                />
              </a>
            </div>

            {/* Spacer to push right content to the right */}
            <div className="flex-1"></div>

            {/* Right section */}
            <div className="flex items-center gap-3">
              {isAuthenticated && (
                <>
                  <AppToggle />
                  <TrackingFeatureGate>
                    <Link
                      to="/tracking_reports"
                      className="flex items-center justify-center text-white transition-colors hover:text-gray-200"
                    >
                      <DocumentTextIcon className="size-6" />
                    </Link>
                  </TrackingFeatureGate>
                  <UserIconMenu displayUsername={user?.email} />
                </>
              )}
            </div>
          </div>
        </div>
        {/* Content */}
        <main className="relative flex-1 overflow-y-auto focus:outline-none">
          {children}
        </main>
      </div>
    </div>
  );
};
